import { render, staticRenderFns } from "./cities1.vue?vue&type=template&id=d659d704&"
import script from "./cities1.vue?vue&type=script&lang=js&"
export * from "./cities1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports